import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y } from 'swiper/modules';
import { getTestimonialData } from '../../data/testimonialData';
import { useT, useLang } from '../../i18n/LanguageContext';
import strings from './TestimonialCarousel.i18n';
import 'swiper/css';
import 'swiper/css/pagination';
import './TestimonialCarousel.css';

export default function TestimonialCarousel() {
  const t = useT(strings);
  const { lang } = useLang();
  const testimonialData = getTestimonialData(lang);

  return (
    <div className="testimonial-carousel">
      <div className="testimonial-carousel__header">
        <p className="testimonial-carousel__label">{t.label}</p>
        <h2 className="testimonial-carousel__title">{t.title}</h2>
      </div>
      <Swiper
        modules={[Pagination, A11y]}
        spaceBetween={16}
        slidesPerView={1}
        grabCursor
        loop
        pagination={{ clickable: true }}
        a11y={{ prevSlideMessage: t.prevSlideMessage, nextSlideMessage: t.nextSlideMessage }}
        breakpoints={{ 768: { slidesPerView: 2 }, 992: { slidesPerView: 3 } }}
      >
        {testimonialData.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div className="testimonial-card">
              <div className={`pill pill-${item.pillColor}`} style={{ alignSelf: 'flex-start', marginBottom: 16 }}>
                {item.industry}
              </div>
              <div className="testimonial-card__metric">{item.metric}</div>
              <div className="testimonial-card__metric-label">{item.metricLabel}</div>
              <div className="testimonial-card__quote">"{item.quote}"</div>
              <p className="testimonial-card__desc">{item.description}</p>
              <div className="testimonial-card__footer">
                <span className="testimonial-card__author">
                  — {item.author}, <span className="testimonial-card__company">{item.company}</span>
                </span>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
